var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16C6.55228 16 7 16.4477 7 17V23C7 23.5523 6.55228 24 6 24C5.44772 24 5 23.5523 5 23V17C5 16.4477 5.44772 16 6 16ZM11 4C11.5523 4 12 4.44772 12 5V23C12 23.5523 11.5523 24 11 24C10.4477 24 10 23.5523 10 23V5C10 4.44772 10.4477 4 11 4ZM16 12C16.5523 12 17 12.4477 17 13V23C17 23.5523 16.5523 24 16 24C15.4477 24 15 23.5523 15 23V13C15 12.4477 15.4477 12 16 12ZM21 8C21.5523 8 22 8.44772 22 9V23C22 23.5523 21.5523 24 21 24C20.4477 24 20 23.5523 20 23V9C20 8.44772 20.4477 8 21 8Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphOutline);
export default __webpack_public_path__ + "static/media/graph_outline.bc9e1fe3103f251ee847d077c8283ac5.svg";
export { ForwardRef as ReactComponent };